// @ts-nocheck
/* eslint-disable */
export const arrowLeftIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="M12.5 17.225a.62.62 0 0 1-.442-.183l-5.433-5.434a2.283 2.283 0 0 1 0-3.216l5.433-5.434a.63.63 0 0 1 .884 0 .63.63 0 0 1 0 .884L7.508 9.275c-.4.4-.4 1.05 0 1.45l5.434 5.433a.63.63 0 0 1 0 .884.66.66 0 0 1-.442.183"/></svg>`,
    name: 'arrow-left' as const
};